<div class="modal-header modal-header-branded">
  <div class="modal-branding-content">
    <!-- <img src="assets/cablepro/img/CablePro-Web-Logo.png" width="60" height="60" alt="Cable Pro Web Logo" /> -->
    <span class="modal-header-branding-text">ELEK Cable Pro Web</span>
  </div>
  <button type="button" class="close" aria-describedby="modal-title"
    (click)="activeModal.dismiss(false)">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body py-2">
  <app-register [isPopup]="true" [isWebFacing]="true"></app-register>
</div>